import { LocationStrategy } from '@angular/common';
import { Component, ElementRef, OnInit, ViewChildren } from '@angular/core';
import { FormBuilder, FormControl, FormControlName, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { ToastrService } from 'ngx-toastr';
import { fromEvent, merge, Observable, Subscription } from 'rxjs';
import { debounceTime } from 'rxjs/operators';
import { ServiceCategory } from 'src/app/db/models/categories';
import { Country, ProService } from 'src/app/db/models/pro-services';
import { User } from 'src/app/db/models/user';
import { GenericValidator } from 'src/app/directives/generic-validator';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { CategoryService } from 'src/app/services/category.service';
import { ProfessionalServiceService } from 'src/app/services/professional-service.service';
import { StatesCitiesService } from 'src/app/services/states-cities.service';
// import randomString from 'randomstring';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-professional-services-edit',
  templateUrl: './professional-services-edit.component.html',
  styleUrls: ['./professional-services-edit.component.scss']
})
export class ProfessionalServicesEditComponent implements OnInit {

  @ViewChildren(FormControlName, { read: ElementRef }) formInputElements: ElementRef[];

  title_main = 'Basic Information';
  title_sub = 'Edit Basic Information'

  pform: FormGroup;

  pro_service = new ProService();
  private sub: Subscription;
  user: User;
  is_edit: boolean;
  accept_creation: boolean;

  categories: ServiceCategory[];
  countries: Country[];
  states: string[];
  cities: string[];

  displayMessage: { [key: string]: string } = {};
  private validationMessages: { [key: string]: { [key: string]: string } };
  private genericValidator: GenericValidator;

  isFreeService = false;
  isRegisteredService = false;

  constructor(private fb: FormBuilder,
        private router: Router,
        private route: ActivatedRoute,
        private url: LocationStrategy,
        private service: ProfessionalServiceService,
        private cservice: CategoryService,
        private sservice: StatesCitiesService,
        private spinner: NgxSpinnerService,
        private authenticate: AuthenticationService,
        private notify: ToastrService)
        {
          this.validationMessages = {
            name: {
              required: 'Service name is required'
          },
          description: {
            required: 'Please describe your service'
          },
          serviceCategoryId:  {
            required: 'Select at least one category'
          },
          contactNumber: {
            required: 'A working mobile contact is required'
          },
          // line: {
          //   required: 'A valid address is required'
          // },
          country:{
            required: 'Please select your country of service'
          },
           state:{
            required: 'Please select your state of service'
          },
          city:{
            required: 'Please select your city of service'
          }
        }

          this.genericValidator = new GenericValidator(this.validationMessages);
          this.authenticate.currentUser.subscribe(x => this.user = x);

          // const response_Url = this.url.path();
          // console.log(response_Url);
          // this.validateCreateService(this.user, response_Url);
        }

  ngOnInit() {
    this.createDataForm();
    this.getCategories();

    this.sub = this.route.paramMap.subscribe(
      params => {
        const id = params.get('id');
        this.getService(id);
      }
    )

    if (this.user != null) {
      this.is_edit = true;
    } else {
      this.is_edit = false;
    }

    // const response_Url = this.url.path();
    // console.log(response_Url);
    // this.validateCreateService(this.user, response_Url);

    this.countries = this.sservice.getCountries();
    this.country.valueChanges.subscribe((country) => {
      this.state.reset();
      this.state.disable();
      if (country) {
        this.states = this.sservice.getStatesByCountry(country);
        this.state.enable();
      }
    });

    this.state.valueChanges.subscribe((state) => {
      this.city.reset();
      this.city.disable();
      if (state) {
        this.cities = this.sservice.getCitiesByState(this.country.value, state);
        this.city.enable();
      }
    });

  }

  createDataForm(){
    this.pform = this.fb.group({
      name: [null, Validators.required],
      description: [null, Validators.required],
      serviceCategoryId: [null, Validators.required],
      contactNumber: [null, Validators.required],
      line: [null],
      country: [null, Validators.required],
      state: [null, Validators.required],
      city: [null, Validators.required],
    })
  }

  ngAfterViewInit(): void {
    const controlBlurs: Observable<any>[] = this.formInputElements
      .map((formControl: ElementRef) => fromEvent(formControl.nativeElement, 'blur'));
    merge(this.pform.valueChanges, ...controlBlurs).pipe(
      debounceTime(800)
    ).subscribe(value => {
      this.displayMessage = this.genericValidator.processMessages(this.pform);
    });
  }

  getCategories(){
   // this.categories = this.cservice.categories;
    this.cservice.getAllServiceCategories().subscribe(
      data => {
        this.categories = data;
      }
    )
  }

  profileRegistration() {
    this.isRegisteredService = true;
  }

  serviceRegistration(){
    this.isFreeService = true;
  }

  get name(){
    return this.pform.controls.name as FormControl;
  }

  get description(){
    return this.pform.controls.description as FormControl;
  }

  get serviceCategoryId(){
    return this.pform.controls.serviceCategoryId as FormControl;
  }

  get contactNumber(){
    return this.pform.controls.contactNumber as FormControl;
  }

  get line(){
    return this.pform.controls.line as FormControl;
  }

  get city() {
    return this.pform.controls.city as FormControl;
  }

  get state() {
    return this.pform.controls.state as FormControl;
  }

  get country() {
    return this.pform.controls.country as FormControl;
  }

  mapEntity(): void {
    this.pro_service.name = this.name.value;
    this.pro_service.description = this.description.value;
    this.pro_service.serviceCategoryId = this.serviceCategoryId.value;
    this.pro_service.primaryContactNumber = this.contactNumber.value;
    this.pro_service.addressLine  = this.line.value;
    this.pro_service.city = this.city.value;
    this.pro_service.state = this.state.value,
    this.pro_service.country = this.country.value;
  }

  saveData(){
    this.spinner.show();
    if(this.pform.valid){
      this.mapEntity();
      console.log('New Service', this.pro_service);
      if (this.pro_service.id != null) {
        this.service.updateService(this.pro_service)
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.updateNotify();
            this.router.navigate([`/profile/${this.user.id}`]);
          },
          error: err => {
            this.spinner.hide();
            this.errorNotification();
          }
        })
      } else {
        this.service.createProfessionalService(this.pro_service)
        .subscribe({
          next: () => {
            this.spinner.hide();
            this.successNotification();

          },
          error: err => {
            this.spinner.hide();
            this.errorNotification();

          }
        })
      }
    }
  }

  successNotification(){
    Swal.fire({
      icon: 'success',
      title: 'Awesome',
      text:'Your Service will now appear in searches',
      showDenyButton: false,
      focusConfirm: true,
      confirmButtonText: '<i class="fa fa-thumbs-up"></i> Ok',
    }).then((result) => {
      if(result.isConfirmed){
        this.abort();
      }
    })
  }

  updateNotify(){
    let timerInterval;
    Swal.fire({
      title: 'Awesome',
      text: 'Update Successful!',
      timer: 1000,
      timerProgressBar: true,
      showConfirmButton: false,
      didOpen: () => {
        Swal.showLoading();
        // const b = Swal.getHtmlContainer().querySelector('b')
        // timerInterval = setInterval(() => {
        //   b.textContent = Swal.getTimerLeft()
        // }, 100)
      },
      willClose: () => {
        clearInterval(timerInterval);
      }
    })
  }

  errorNotification(){
    Swal.fire({
      icon: 'error',
      title: 'Oops',
      text: 'Service with the same name already exist!',
      showDenyButton: true,
      focusConfirm: false,
      confirmButtonText: '<i class="fa fa-repeat"></i> Try Again!',
      denyButtonText: `<i class="fa fa-power-off"></i> Cancel`,
    }).then((result) => {
      if (result.isConfirmed) {
        this.reload();
      } else {
        this.abort();
      }
    })
  }

  abort(){
    //  this.router.navigate(['/']);
    if(this.pro_service.id != null){
      this.router.navigate([`/profile/${this.user.id}`]);
     } else {
      this.router.navigate(['/']);
      // this.notify.info('Trepez','Operation Aborted!!');
     }
    }

  reload(){
    //  this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
    //    this.router.navigate(['create_service']);
    //  })
    if(this.pro_service.id != null){
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate([`/edit_service/${this.pro_service.id}`]);
      })
     } else {
      this.router.navigateByUrl('/', { skipLocationChange: true }).then(() => {
        this.router.navigate(['create_service']);
      })
     }
    }

    getService(id:string){
      this.service.getserviceDetail(id).subscribe({
        next: (res: ProService) => this.displayProfile(res),
        error: err => console.log("Form Reset")
        // error: err => this.notify.info('Trepez', 'Form Reset Successful...')
      })
    }

    displayProfile(data: ProService): void{
      if(this.pform){
        this.pform.reset();
      }
      this.pro_service = data;
       if(this.pro_service.id === null) {
        this.title_main = 'Basic Information';
        } else {
          this.title_main = 'Edit Basic Information';
        }
      this.pform.patchValue({
        name: this.pro_service.name,
        description: this.pro_service.description,
        line: this.pro_service.addressLine,
        contactNumber: this.pro_service.primaryContactNumber,
        serviceCategoryId: this.pro_service.serviceCategoryId,
        city: this.pro_service.city,
        state: this.pro_service.state,
        country: this.pro_service.country
      });
    }

    // validateCreateService(user:User){
    //   if(user.serviceId !== null){
    //     this.accept_creation = false;
    //     this.is_edit = true;
    //   }
    //   if(user === null && url_route === myroute){
    //     this.accept_creation = true;
    //     console.log("accept creation passed")
    //   }
    // }

    confirmSignOut(){
      this.authenticate.logout();
      this.router.navigate(['/']);
      this.notify.success('Logged Out Succesfully');
    }

}
